import { CityListPage } from "@/features/geolocation/page/CityListPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/geolocation/city/")({
  component: CityListPage,
});
